export enum CncAdsForceArea {
  HOMEPAGE = 'homepage',
  OSTATNI = 'ostatni',
}